import React from 'react'
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native'
import { createNativeStackNavigator, NativeStackNavigationProp } from '@react-navigation/native-stack'
import {
  Profile,
  AddMemory,
  ShowMemory,
  AlbumMemories,
  Edit,
  MyMemories,
  Contextes,
} from '@screens'
import { AddGhostContact } from '../../screens/contacts/addGhostContact'
import { DetailsGhostProfile } from '../../screens/contacts/detailsGhostProfile'

export type ScreenProfileProps<RouteName extends keyof ProfileStackParamList> = {
  navigation: CompositeNavigationProp<
    NativeStackNavigationProp<ProfileStackParamList, RouteName>,
    NativeStackNavigationProp<ProfileStackParamList, keyof ProfileStackParamList>
  >
  route: RouteProp<ProfileStackParamList, RouteName>
}

export type ProfileStackParamList = {
  ProfileHome: undefined
  ProfileMemories: {
    profileId?: string
  }
  ProfileAddMemory: {
    memoryId?: string
    profileId?: string
    preselectedImages?: string[]
    albumId?: string
  }
  ProfileShowMemory: {
    memoryId: string
    readonly?: boolean
  }
  ProfileAlbumMemories: {
    albumId: string
    readonly?: boolean
  }
  ProfileContact: undefined
  ProfilePresentation: undefined
  ProfileEdit: undefined
  ProfileAvailability: undefined
  ProfileAddAvailabilitySlot: {
    isEdit?: boolean
    slotId?: string
  } | undefined
  ProfileAbout: undefined
  AddGhostContact: undefined
  EditGhostContact: {
    profileId?: string
  }
  DetailsGhostProfile: {
    profileId: string
  }
  ProfileContextes: {
    profileId: string
  }
}

const ProfileStack = createNativeStackNavigator<ProfileStackParamList>()

export const ProfileNavigator = () => {
  return (
    <ProfileStack.Navigator screenOptions={{ headerShown: false }}>
      <ProfileStack.Screen name="ProfileHome" component={Profile} />
      <ProfileStack.Screen name="ProfileMemories" component={MyMemories} />
      <ProfileStack.Screen name="ProfileAddMemory" component={AddMemory} />
      <ProfileStack.Screen name="ProfileShowMemory" component={ShowMemory} />
      <ProfileStack.Screen name="ProfileAlbumMemories" component={AlbumMemories} />
      <ProfileStack.Screen name="ProfileEdit" component={Edit} />
      <ProfileStack.Screen name="AddGhostContact" component={AddGhostContact} />
      <ProfileStack.Screen name="EditGhostContact" component={AddGhostContact} />
      <ProfileStack.Screen name="DetailsGhostProfile" component={DetailsGhostProfile} />
      <ProfileStack.Screen name="ProfileContextes" component={Contextes} />
    </ProfileStack.Navigator>
  )
}
